import React from "react";
import { LegacyIcons } from "components/elements/Icon";

import Icon from "components/elements/Icon";
import ManaFrontIcon, { ManaFontIcons } from "components/misc/customIcons/ManaFont";
import CustomIcon, { CustomIcons } from "components/elements/CustomIcon";

import { ctrlConverter } from "utils/macosLegendHelper";

import styles from "./button.module.scss";

type ButtonProps = {
  id?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  onContextMenu?: React.MouseEventHandler<HTMLButtonElement>;
  icon?: LegacyIcons;
  manaFontIcon?: ManaFontIcons;
  customIcon?: CustomIcons;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  labelClass?: string;
  disabled?: boolean;
  keybind?: string;
};

// This button is the default and has transitions and media queries built into it
const Button = (props: ButtonProps) => (
  <SimpleButton {...props} className={`${props.className} ${styles.transition}`} />
);

// This button will remove the label on smaller screens
export const ShrinkButton = (props: ButtonProps) => (
  <SimpleButton {...props} className={`${props.className} ${styles.transition}`} labelClass={styles.buttonContent} />
);

// This button is simple, and doesn't do anything fancy (also used as the basis to build all other buttons)
export const SimpleButton = (props: ButtonProps) => {
  const {
    id,
    onClick,
    onContextMenu,
    icon,
    manaFontIcon,
    customIcon,
    keybind = "",
    children = null,
    style = {},
    className = "",
    labelClass = "",
    disabled = false,
  } = props;

  const displayKeybind = ctrlConverter(keybind);

  return (
    <button
      type='button'
      id={id}
      onClick={onClick}
      onContextMenu={onContextMenu}
      style={style}
      className={`
        ${styles.button}
        ${keybind ? styles.keybindButton : ""}
        ${className}
      `}
      disabled={disabled}>
      <span className={styles.primaryContent}>
        {icon && <Icon name={icon} />}
        {manaFontIcon && <ManaFrontIcon icon={manaFontIcon} />}
        {customIcon && <CustomIcon name={customIcon} />}
        {children && <span className={labelClass}>{children}</span>}
      </span>
      {displayKeybind && (
        // Surpessing hydration warning to prevent screaming regarding a difference in Cmd vs Ctrl for apple vs non apple devices
        // TODO - maybe try to force this to a non server component
        <span suppressHydrationWarning className={styles.keybind}>
          {displayKeybind}
        </span>
      )}
    </button>
  );
};

export default Button;
